module.exports = __webpack_public_path__ + "media/images/flags/PY-9814f157d4ccafbbe81e5f311608fa22.svg";